import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { FileText } from 'lucide-react';

export const ContactModal = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  const handleStartUpload = () => {
    onOpenChange(false);
    navigate('/upload');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]" style={{ border: '1px solid var(--color-border)' }}>
        <DialogHeader>
          <DialogTitle className="text-2xl" style={{ color: 'var(--color-navy)' }}>Get Your Schedule of Works</DialogTitle>
          <DialogDescription style={{ color: 'var(--color-muted)' }}>
            Upload your project details and receive a professional Schedule of Works with accurate pricing.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="p-4 rounded-lg space-y-3" style={{ backgroundColor: 'var(--color-bg)', border: '1px solid var(--color-border)' }}>
            <h4 className="font-semibold" style={{ color: 'var(--color-text)' }}>What you'll need:</h4>
            <ul className="text-sm space-y-2 list-disc list-inside" style={{ color: 'var(--color-muted)' }}>
              <li>Project details and address</li>
              <li>Scaled drawings (preferred)</li>
              <li>Photos of the property</li>
              <li>Floor area and number of units</li>
            </ul>
          </div>

          <div className="p-4 rounded-lg flex items-center gap-3" style={{ backgroundColor: 'var(--color-bg)', border: '1px solid var(--color-border)' }}>
            <FileText className="w-5 h-5 flex-shrink-0" style={{ color: 'var(--color-navy)' }} />
            <p className="text-sm" style={{ color: 'var(--color-muted)' }}>
              Our pricing calculator will provide an instant quote based on your project details
            </p>
          </div>

          <button
            onClick={handleStartUpload}
            className="btn-primary w-full py-4 text-base"
            data-testid="modal-start-upload-btn"
          >
            Start Upload Process
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
